var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pdf-svgrepo-com",
    transform: "translate(0 -0.4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_150237",
    "data-name": "Rectangle 150237",
    width: 56,
    height: 56,
    rx: 9,
    transform: "translate(0 0.4)",
    fill: "#b83f3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50852",
    "data-name": "Path 50852",
    d: "M128.731,120.416c-.989-1.1-3.187-1.648-6.154-1.648a39.667,39.667,0,0,0-5.824.549,27.691,27.691,0,0,1-5.714-7.582,30.734,30.734,0,0,0,1.868-8.9c0-1.868-.659-4.835-3.3-4.835a2.266,2.266,0,0,0-1.868,1.1c-1.1,1.978-.659,6.373,1.428,10.988a98.676,98.676,0,0,1-5.494,12.856c-5.824,2.417-9.67,5.055-10,7.142-.22.989.44,2.637,2.747,2.637,3.406,0,7.142-4.945,10-10a68.787,68.787,0,0,1,10.109-2.637c4.176,3.626,7.8,4.176,9.56,4.176C129.61,124.262,129.939,121.735,128.731,120.416ZM108.292,99.428c.879-1.319,2.857-.879,2.857,1.758A27.985,27.985,0,0,1,109.5,109.1C107.523,104.483,107.523,100.857,108.292,99.428ZM94.337,130.2c.33-1.758,3.626-4.176,8.791-6.263-2.857,4.835-5.714,7.912-7.472,7.912A1.345,1.345,0,0,1,94.337,130.2Zm21.647-10.769a63.072,63.072,0,0,0-9.12,2.417,49.778,49.778,0,0,0,3.956-9.23,35.933,35.933,0,0,0,5.165,6.813Zm1.428.44a27.561,27.561,0,0,1,7.8-.22c3.187.659,2.088,4.505-1.428,3.626A15.5,15.5,0,0,1,117.412,119.867Z",
    transform: "translate(-83.348 -87.092)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.7cfcff319cb1f67a162026b07aec1a00.svg";
export { ForwardRef as ReactComponent };